// WebBleStatusBadge — indicador GLOBAL (en cualquier página) del estado de la impresora
// Bluetooth. Resuelve dos requisitos:
//
// 1. Aviso accionable: si hay alguna impresora emparejada+habilitada SIN conexión, el
//    usuario debe enterarse antes de intentar imprimir y fallar sin saber por qué.
//    Esto cubre el caso multi-impresora (p.ej. Caja conectada + Cocina caída): mientras
//    falte aunque sea una, mostramos la barra "por confirmar".
//
// 2. Confirmación positiva: cuando TODAS las emparejadas+habilitadas están conectadas,
//    mostramos una píldora verde sutil ("Impresora lista") para que el cajero en Pedidos
//    sepa de un vistazo que puede imprimir. Discreta, no una barra de alarma.
//
// En 'off'/'unsupported' no se muestra nada. Tocar el aviso lleva a Ajustes › Impresión.

import { useNavigate } from 'react-router-dom';
import { useWebBleReady } from '@utils/hooks/useWebBleReady';

const PRINTING_DEEP_LINK = '/ajustes?section=printing';

export const WebBleStatusBadge = () => {
  const navigate = useNavigate();
  const { status, pairedCount, connectedCount } = useWebBleReady();

  if (status === 'off' || status === 'unsupported') return null;

  // Estado positivo: todo conectado → píldora verde compacta, no intrusiva.
  if (status === 'ready') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '6px 12px',
        }}
      >
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            borderRadius: 999,
            border: '1px solid rgba(8,195,128,0.3)',
            background: 'rgba(8,195,128,0.1)',
            color: '#04AF00',
            padding: '3px 10px',
            fontSize: 12,
            fontWeight: 600,
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
          }}
        >
          <span aria-hidden>🖨️</span>
          <span>Impresora lista</span>
        </span>
      </div>
    );
  }

  // Estado por confirmar: al menos una emparejada+habilitada sin conexión.
  const pendingCount = pairedCount - connectedCount;
  const message =
    pendingCount > 1
      ? `Confirma tus impresoras Bluetooth (${pendingCount} por confirmar) — toca aquí`
      : 'Confirma tu impresora Bluetooth para dejarla lista — toca aquí';

  return (
    <button
      type="button"
      onClick={() => navigate(PRINTING_DEEP_LINK)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        width: '100%',
        border: 0,
        borderBottom: '1px solid #CDE6EE',
        background: '#F4FBFC',
        color: '#327A95',
        padding: '7px 12px',
        fontSize: 12.5,
        fontWeight: 600,
        cursor: 'pointer',
        textAlign: 'center',
      }}
    >
      <span aria-hidden>🖨️</span>
      <span>{message}</span>
    </button>
  );
};
